export const ELEMENT_TYPES = [
  { value: "raam", label: "Raam" },
  { value: "deur", label: "Deur" },
  { value: "schuifraam", label: "Schuifraam" },
  { value: "velux", label: "Veluxraam" },
  { value: "garagepoort", label: "Garagepoort" },
];

export const ELEMENT_TYPE_LABEL = ELEMENT_TYPES.reduce((a, t) => ({ ...a, [t.value]: t.label }), {});

export const KLEUREN = ["Wit", "Crème", "RAL / Andere..."];
export const MATERIALEN = ["PVC", "Aluminium", "Hardhout"];
export const VERDELING = ["1 deel", "2 delen", "3 delen", "4 delen"];
export const ONDERVERDELING = ["Vast raam", "Draai-kiep", "Kantelraam", "Andere verdeling"];
export const GLASKEUZE = ["Helder glas", "Mat glas", "UV-werend", "Paneel"];
export const BEGLAZING = ["Dubbelglas (max Ug 1.0)", "Driedubbel glas (Ug 0.7)"];
export const VENTILATIE = ["Geen ventilatie", "Renson op het frame", "Renson in het glas"];
export const ROLLUIK = ["Nee", "Ja"];

export const MEETHANDLEIDING_PDF = "https://customer-assets.emergentagent.com/job_nl-employment/artifacts/32duspfr_Hoe%20ramen%20en%20deuren%20opmeten.pdf";

export const BEDRIJF_STATUS_LABEL = {
  open: "In afwachting",
  offerte_verstuurd: "Offerte verstuurd",
  niet_geinteresseerd: "Niet geïnteresseerd",
};

export const emptyElement = () => ({
  _id: (crypto.randomUUID ? crypto.randomUUID() : String(Math.random())),
  type: "Raam", breedte: "", hoogte: "", aantal: 1,
  kleur_binnen: "Wit", kleur_buiten: "Wit", materiaal: "PVC",
  verdeling: "1 deel", onderverdeling: "Vast raam", glaskeuze: "Helder glas",
  beglazing: "Dubbelglas (max Ug 1.0)", ventilatie: "Geen ventilatie", rolluik: "Nee", opmerkingen: "",
});
